import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id A22472A9-D83E-4234-AAF0-F60AFB7C57DB
 * name cube-unfolded
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cube-unfolded.svg
 * tags
 */
export const CubeUnfoldedIcon = createSvgIcon(<><path d="M6,9V4H13V9H23V16H18V21H11V16H1V9H6M16,16H13V19H16V16M8,9H11V6H8V9M6,14V11H3V14H6M18,11V14H21V11H18M13,11V14H16V11H13M8,11V14H11V11H8Z" /></>, 'CubeUnfoldedIcon');
export default CubeUnfoldedIcon